import { useContext, useState } from 'react';

import {
  DEFAULT_TOAST_DATA,
  DOWNLOAD_REPORT_RF_SUCCESS_TOAST,
  DOWNLOAD_REPORT_DEFAULT_SUCCESS_TOAST,
  DOWNLOAD_REPORT_RF_ERROR_TOAST,
  DOWNLOAD_REPORT_DEFAULT_ERROR_TOAST
} from '../../constants/toast';
import { CompanyContext } from '../../context/company/companyContext';
import { IToast } from '../../interfaces/toast';
import MetricsByCompany from '../../services/api/metrics/metricsByCompany/metrics';
import TagManagerService from '../../services/gtm/tagManagerService';
import { downloadFile } from '../../utils/utils';
import { isEmptyObject } from '../../utils/validation/validation';

interface UseMonthlyReportDownloadOptions {
  tagManagerData: {
    clickEvent: string;
    successEvent: string;
    errorEvent: string;
    gtmParams?: any;
  };
  companyId: string;
  date?: string;
}

export const useMonthlyReportDownload = ({ tagManagerData, companyId, date }: UseMonthlyReportDownloadOptions) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastData, setToastData] = useState<IToast>(DEFAULT_TOAST_DATA);
  const { isSpain } = useContext(CompanyContext);
  const successToastData = isSpain ? DOWNLOAD_REPORT_RF_SUCCESS_TOAST : DOWNLOAD_REPORT_DEFAULT_SUCCESS_TOAST;
  const errorToastData = isSpain ? DOWNLOAD_REPORT_RF_ERROR_TOAST : DOWNLOAD_REPORT_DEFAULT_ERROR_TOAST;

  const downloadMonthlyReport = async () => {
    try {
      setLoading(true);
      const response = await MetricsByCompany.getMonthlyReport(companyId, date);
      if (isEmptyObject(response)) {
        setShowModal(true);
        return;
      }

      if (tagManagerData.gtmParams) {
        TagManagerService.pushEvent(tagManagerData.clickEvent, tagManagerData.successEvent, tagManagerData.gtmParams);
      } else {
        TagManagerService.pushEvent(tagManagerData.clickEvent, tagManagerData.successEvent);
      }

      downloadFile(response.url);
      setToastData(successToastData);
      setShowToast(true);
    } catch {
      TagManagerService.pushEvent(tagManagerData.clickEvent, tagManagerData.errorEvent);
      setToastData(errorToastData);
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const closeToast = () => setShowToast(false);
  const closeModal = () => setShowModal(false);

  return {
    loading,
    showModal,
    showToast,
    toastData,
    downloadMonthlyReport,
    closeToast,
    closeModal,
    setLoading
  };
};
